<template>
  <v-row no-gutters justify="end">
    <Arrow
      :data-test-id="`${dataTestId}__start-page-arrow`"
      @changePage="prevPage"
      isActive="true"
      :pageNumberLinks="pageNumberLinks"
      :currentPage="currentPage"
      :page="1"
    />
    <PageNumber
      :data-test-id="`${dataTestId}__page-number-list`"
      :pageNumberLinks="pageNumberLinks"
      :currentPage="currentPage"
      @settingPage="setPage($event)"
    />
    <Arrow
      :data-test-id="`${dataTestId}__end-page-arrow`"
      @changePage="nextPage"
      :pageNumberLinks="pageNumberLinks"
      :currentPage="currentPage"
      :page="totalPages"
    />
  </v-row>
</template>
<script>
import PageNumber from '@/components/Common/Pagination/PageNumber';
import Arrow from '@/components/Common/Pagination/Arrow';
export default {
  data() {
    return {
      currentPage: null,
      currentIndex: 0,
      pageNumberLinks: [],
      totalPages: 0
    };
  },
  props: {
    totalRecords: Number,
    recordsPerPage: Number,
    pageNumber: {
      type: Number,
      default: 1
    },
    dataTestId: String
  },
  components: {
    PageNumber,
    Arrow
  },
  watch: {
    recordsPerPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.setupPagination();
      }
    },
    totalRecords: function() {
      this.currentPage = this.pageNumber;
      this.setupPagination();
    },
    pageNumber: function(value) {
      this.currentPage = value;
    }
  },
  methods: {
    prevPage() {
      if (this.currentPage === 1) {
        return;
      }
      this.currentPage = 1;

      this.$emit('pageChanged', this.currentPage);
      this.setStartEnd();
    },
    nextPage() {
      if (this.currentPage === this.totalPages) {
        return;
      }
      this.currentPage = this.totalPages;

      this.$emit('pageChanged', this.currentPage);
      this.setStartEnd();
    },
    setPage({ page, index }) {
      this.currentPage = page;
      this.currentIndex = index;
      this.setStartEnd();
      this.$emit('pageChanged', this.currentPage);
    },
    setStartEnd(start, end) {
      if (this.totalRecords === 0) {
        return;
      }

      const padding = 2;
      start = this.currentPage - padding;
      end = this.currentPage + padding;

      if (start < 1) {
        end = start === 0 ? end + 1 : end + padding;
        start = 1;
      }
      if (end > this.totalPages) {
        start =
          end - 1 === this.totalPages
            ? start - 1
            : start - padding < 1
            ? 1
            : start - padding;
        end = this.totalPages;
        start = start < 1 ? 1 : start;
      }

      this.pageNumberLinks = [];
      for (let i = start; i <= end; i++) {
        this.pageNumberLinks.push(i);
      }
    },
    setupPagination() {
      this.totalPages = Math.ceil(this.totalRecords / this.recordsPerPage);
      this.setStartEnd();
    }
  },
  mounted() {
    this.currentPage = this.pageNumber;
    this.setupPagination();
  }
};
</script>
